export function InchesToFeetAndInches(totalInches) {
  const feet = Math.floor(totalInches / 12); // Calculate the whole number of feet
  const inches = Number((totalInches % 12).toFixed(3)); // Calculate the remaining inches
  return `${feet}' ${inches}"`;
}
